const SYSTEMS: readonly (readonly [RegExp, string])[] = [
  [/iPhone|iPad/, 'iOS'],
  [/Android/, 'Android'],
  [/Mac/, 'macOS'],
  [/Windows/, 'Windows'],
  [/Linux/, 'Linux'],
];
const BROWSERS: readonly (readonly [RegExp, string])[] = [
  [/Firefox\//, 'Firefox'],
  [/Edg\//, 'Edge'],
  [/Chrome\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

/** "Safari · iOS": how the device is named in the server's sessions. */
export function deviceName(userAgent: string = navigator.userAgent): string {
  const system = SYSTEMS.find(([pattern]) => pattern.test(userAgent))?.[1] ?? 'Device';
  const browser = BROWSERS.find(([pattern]) => pattern.test(userAgent))?.[1] ?? 'Browser';
  return `${browser} · ${system}`;
}
